import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppLoader from '../../common-components/AppLoader';
import useGetCurrentUser from './hooks/useGetCurrentUser';
import { Sidebar } from './components/Sidebar';
import Header from '../MainLayout/components/Header';
import { useSideBarHandler } from './hooks/useSideBarHandler';
import useSingleSessionViewHandler from './hooks/useSingleSessionViewHandler';
import SingleSessionView from './components/SingleSessionView';
import UserSessionsList from './components/UserSessionsList';
import useUserSessionsListHandler from './hooks/useUserSessionsListHandler';

export default function AdminLayoutContent() {
  const { currentUser, isCurrentUserLoading } = useGetCurrentUser();
  const { isSidebarOpen, xsScreen, toggleSidebar } = useSideBarHandler();
  const { selectedSessionIsdToView } = useSingleSessionViewHandler();
  const { selectedUserToView } = useUserSessionsListHandler();
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100dvh',
        width: '100%',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      {isCurrentUserLoading || !currentUser ? (
        <Box sx={{ flex: 1, display: 'grid', placeItems: 'center' }}>
          <AppLoader />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'stretch',
            position: 'relative',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <Sidebar />
          <Box sx={{ display: 'flex', flex: 1, marginLeft: isSidebarOpen && !xsScreen ? '280px' : xsScreen ? 0 : '60px', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
            {isSidebarOpen ? null : <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}
            <Outlet />
          </Box>
          <SingleSessionView sessionId={selectedSessionIsdToView} />
          <UserSessionsList userId={selectedUserToView} />
        </Box>
      )}
    </Box>
  );
}
